import { createSlice } from "@reduxjs/toolkit";
import { HomePageState } from "../../../lib/types/screen";

const initialState: HomePageState ={
    popularBooks: [],
    newBooks: [],
    topUsers: [],
};

const homePageSlice = createSlice({
    name: "homePage",
    initialState,
    reducers: {
        setPopularBooks: (state, action) => {
            state.popularBooks = action.payload;
        },
        setNewBooks: (state, action) => {
            state.newBooks = action.payload;
        },
         setTopUsers: (state, action) => {
            state.topUsers = action.payload;
        },
    },
});

export const {setPopularBooks, setNewBooks, setTopUsers} = 
  homePageSlice.actions;

  const HomePageReducer = homePageSlice.reducer;
  export default HomePageReducer;